import { accessMeta } from '@md/permissions'

export const REDIRECTS = {
  student: 'profile:dashboard:list-common',
  parent: 'profile:dashboard:list-common',
  company: 'profile:dashboard:list-common',
  child: 'profile:dashboard:list-common',
  employee: 'profile:dashboard:list-common',
  teacher: 'profile:dashboard:list-teacher',
  manager: 'profile:orders:list',
}

const { userType, isMainWithChilds } = window

// Патрон нової архітектури — це type_user='student' з is_main та дітьми.
// Він не має старого типу 'parent', тож додаємо віртуальний токен 'main_student'
// лише для роутів, які його явно перелічують. Існуючі перевірки не зачіпаємо.
const isMainStudent = 'student' === userType && 'true' === isMainWithChilds

const initialRoute = { name: REDIRECTS[userType] }

export const permissionChecker = perms => (
  perms.includes(userType)
  || (isMainStudent && perms.includes('main_student'))
)

export const accessPermission = (permissions, options) => accessMeta(
  permissionChecker(permissions), initialRoute, options
)
